<script>
	import Footer from '$lib/components/footer.svelte';
	import bg from '$lib/images/bg.jpeg';
	import trueselfLogo from '$lib/images/trueself_logo_full_wt.svg';
	import appMockup from '$lib/images/sales/app_mockup.webp';
	import socialScare from '$lib/images/social_share.jpg';
	import soulprintLifeAreasScreenshot from '$lib/images/soulprint_life_areas_screenshot.webp';
	import soulprintSystemScreenshot from '$lib/images/soulprint_system_screenshot.webp';
	import headphone from '$lib/images/headphone.svg';
	import symbolFramworkEnnegram from '$lib/images/symbol_framework_enneagram.svg';
	import symbolFramworkHumandesign from '$lib/images/symbol_framework_humandesign.svg';
	import symbolFramworkGenekeys from '$lib/images/symbol_framework_genekeys.svg';
	import symbolFramworkWesternastrology from '$lib/images/symbol_framework_westernastrology.svg';
	import symbolFramworkVedicastrology from '$lib/images/symbol_framework_vedicastrology.svg';
	import symbolFramworkChineseastrology from '$lib/images/symbol_framework_chineseastrology.svg';
	import symbolFramworkSpiraldynamics from '$lib/images/symbol_framework_spiraldynamics.svg';
	import symbolFramworkNumerology from '$lib/images/symbol_framework_numerology.svg';
	import symbolInteraction from '$lib/images/symbol_framework_interaction.svg';
	import textEnneagram from '$lib/images/symbol_texts/enneagram.svg';
	import textWesternAstrology from '$lib/images/symbol_texts/western_astrology.svg';
	import textVedicAstrology from '$lib/images/symbol_texts/vedic_astrology.svg';
	import textGeneKeys from '$lib/images/symbol_texts/gene_keys.svg';
	import textHumanDesign from '$lib/images/symbol_texts/human_design.svg';
	import textChineseAstrology from '$lib/images/symbol_texts/chinese_astrology.svg';
	import textSpiralDynamics from '$lib/images/symbol_texts/spiral_dynamics.svg';
	import textNumerology from '$lib/images/symbol_texts/numerology.svg';
	import starsLines from '$lib/images/stars_lines.webp';
	import starsLinesXS from '$lib/images/stars_lines_xs.webp';
	import user1 from '$lib/images/sales/user_1.webp';
	import user2 from '$lib/images/sales/user_2.webp';
	import user4 from '$lib/images/sales/user_4.webp';
	import SalesTestimonials from '$lib/components/sales-testimonials.svelte';
	import testimonialMsg1 from '$lib/images/sales/testimonials/img_testimonial_msg_1.jpg';
	import testimonialMsg2 from '$lib/images/sales/testimonials/img_testimonial_msg_2.jpg';
	import testimonialMsg3 from '$lib/images/sales/testimonials/img_testimonial_msg_3.jpg';
	import personCarl from '$lib/images/sales/person/img_qoute_carl.jpg';
	import personTole from '$lib/images/sales/person/img_qoute_tole.jpg';
	import personBrown from '$lib/images/sales/person/img_quote_brown.jpg';
	import SalesBigFigures from '$lib/components/sales-big-figures.svelte';
	import iconHeart from '$lib/images/icons/icon_heart.svg';
	import iconEye from '$lib/images/icons/icon_eye.svg';
	import iconStar from '$lib/images/icons/icon_star.svg';
	import iconGraph from '$lib/images/icons/icon_graph.svg';
	import iconPuls from '$lib/images/icons/icon_puls.svg';
	import iconSuitcase from '$lib/images/icons/icon_suitcase.svg';
	import iconIndividualWt from '$lib/images/icons/icon_individual_wt.svg';
	import iconThemselvesWt from '$lib/images/icons/icon_themselves_wt.svg';
	import iconRelationshipsWt from '$lib/images/icons/icon_relationships_wt.svg';
	import iconTalentsWt from '$lib/images/icons/icon_talents_wt.svg';
	import iconInnovativeWt from '$lib/images/icons/icon_innovative_wt.svg';
	import iconPeakWt from '$lib/images/icons/icon_peak_wt.svg';
	import iconUnityWt from '$lib/images/icons/icon_unity_wt.svg';
	import iconEye2Wt from '$lib/images/icons/icon_eye2_wt.svg';
	import arrowIconB from '$lib/images/icons/icon_arrow_b.svg';
	import SalesAboutCard from '$lib/components/sales-about-card.svelte';
	import appMockup1 from '$lib/images/sales/app-mockup-1.webp';
	import appMockup2 from '$lib/images/sales/app-mockup-2.webp';
	import FreeSoulprintFaq from '$lib/components/blocks/free-soulprint-faq.svelte';
	import AppWrapper from '$lib/components/app-wrapper.svelte';
	import ButtonPrimary from '$lib/components/button-primary.svelte';
	import ButtonSecondaryLight from '$lib/components/button-secondary-light.svelte';
	import AudioPlayerOriginal from '$lib/components/audio-player-original.svelte';

	import { register } from 'swiper/element/bundle';
	register();

  import { onMount } from "svelte";
	import { animateBatch } from "$lib/gsapAnimate.js";
	import { Util } from '$lib/utils';
	import { goto } from '$app/navigation';
	import { page } from '$app/stores';

	let isLoggedIn = false;
	let user;

	function scrollToSection() {
        const hash = window.location.hash; // Get the hash from URL
        if (hash) {
            const section = document.querySelector(hash);
            if (section) {
                section.scrollIntoView({ behavior: "smooth" });
            }
        }
    }

  function gotoTest() {
    const searchParams = $page.url.searchParams;
    const params = new URLSearchParams(searchParams).toString();
    goto(`/personality-test?${params}`);
  }

	let swiperEl;

	onMount(() => {
		scrollToSection()
		user = Util.getLoggedInUserInfo()
			if(user == null){
				isLoggedIn = false;
			}else{
				isLoggedIn = true;
			}
			animateBatch(); 
		if (!swiperEl) return;

		const isMobile = window.innerWidth < 768;

		Object.assign(swiperEl, {
			autoplay: { delay: 5000 },
			spaceBetween: 30,
			slidesPerView: 1,
			pagination: true,
			navigation: true,
			speed: 500,
			keyboard: true,
			autoHeight: isMobile,
			grabCursor: true,
			loop: true,
		});

		swiperEl.initialize(); 
	});


</script>

<svelte:head>
	<meta property="og:image" content="https://soulprint.trueself.io/_app/immutable/assets/social_share.CdarJ4Dq.jpg">
	<meta property="og:image:type" content="image/jpg">
	<meta property="og:image:width" content="1621 ">
	<meta property="og:image:height" content="735">
	<meta property="og:url" content="https://soulprint.trueself.io/"/>
 	<meta property="og:title" content="Discover Your TRUE SELF" />
	<meta property="og:description" content="A TrueSelf Personality Reading will help you unlock your hidden gifts and potential, deepen your awareness of your life purpose and secret talents." />
</svelte:head>
<!-- Homepage Page -->
<AppWrapper>
	<!-- Homepage Header -->
	 <section class="overflow-hidden p-2.5 bg-white before:fixed before:inset-x-0 before:bg-white before:h-40 before:-top-5 before:-z-10">
		  <div class="relative z-0 text-white pt-[180px] md:pt-32 xl:pt-[60px] pb-10 md:pb-20 rounded-[20px] md:rounded-[30px] after:-z-10 after:bg-black/40 after:rounded-[20px] md:after:rounded-[30px] after:inset-0 after:size-full after:absolute">
				<div class="absolute top-8 left-7">
						<img width="70" height="84" src={trueselfLogo} alt="symbol"/>
				</div>
				<div class="absolute top-5 right-5">
					<!-- {#if !isLoggedIn} -->
					<button class="border border-white/20 border-solid text-white w-[97px] md:w-[113px] h-10 flex items-center justify-center rounded-3xl pb-0.5 font-light tracking-wider text-base uppercase" on:click={()=>{goto(isLoggedIn ? '/soulprint' : '/login')}} >Sign In</button>
					<!-- {/if} -->
				</div>
				<img class="bg-cover absolute inset-0 size-full -z-10 rounded-[20px] md:rounded-[30px]" src={bg} alt="background" />
				<div class="-ml-5 mr-0 sm:mx-auto md:h-[666px] overflow-hidden">
				<swiper-container init="false" bind:this={swiperEl}>
					<swiper-slide class="h-auto md:h-full">
						<div class="max-w-[1083px] md:px-5 -ml-5 mr-0 sm:mx-auto overflow-hidden">
							<div class="grid grid-cols-[176px_211px] justify-center md:grid-cols-[336px_1fr] items-center gap-2 md:gap-10 lg:gap-[72px] md:pl-5 pb-10 lg:pb-0">
								<div class="animate-shake relative z-10 md:rotate-[-5deg]">
									<img class="bg-cover" width="336" height="666" src={appMockup} alt="mockup" />
								</div>
								<div class="flex flex-col items-center md:items-start md:pt-7 gap-5 md:gap-12">
									<h1 class="animate-up break-words text-[42px] md:text-[65px] leading-none font-light after:bg-star after:bg-no-repeat after:size-4 after:inline-block after:relative after:-top-1.5 after:-right-1.5"><span class="opacity-70">Discover the most </span><b class="font-semibold">accurate, precise, holistic</b> <span class="opacity-70">personality profile ever</span></h1>
									<div class="animate-up hidden md:flex justify-center md:justify-start">
										<ButtonPrimary className="text-xl !font-semibold"  onClick={gotoTest} title="Take the Free Test Now" />
									</div>
								</div>
							</div>
						</div>
					</swiper-slide>
					<swiper-slide class="h-auto md:h-full">
						<div class="max-w-[1083px] md:px-5 -ml-5 mr-0 sm:mx-auto overflow-hidden">
						<div class="grid grid-cols-[176px_211px] justify-center md:grid-cols-[336px_1fr] items-center gap-2 md:gap-10 lg:gap-[72px] md:pl-5 pb-10 lg:pb-0">
							<div class="relative z-10 md:rotate-[-5deg]">
								<img class="bg-cover" width="336" height="666" src={appMockup2} alt="mockup" />
							</div>
							<div class="flex flex-col items-center md:items-start md:pt-7 gap-5 md:gap-12">
								<h1 class="animate-up break-words text-[42px] md:text-[65px] leading-none font-light after:bg-star after:bg-no-repeat after:size-4 after:inline-block after:relative after:-top-1.5 after:-right-1.5"><b class="font-semibold">A living library of you.</b> <span class="opacity-70">Your cosmic guide brings your Soulprint to life through interactive chat</span></h1>
								<div class="hidden md:flex justify-center md:justify-start">
									<ButtonPrimary className="text-xl !font-semibold"  onClick={gotoTest} title="Take the Free Test Now" />
								</div>
							</div>
						</div>
					</div>
					</swiper-slide>
					<swiper-slide class="h-auto md:h-full">
						<div class="max-w-[1083px] md:px-5 -ml-5 mr-0 sm:mx-auto overflow-hidden">
						<div class="grid grid-cols-[176px_211px] justify-center md:grid-cols-[336px_1fr] items-center gap-2 md:gap-10 lg:gap-[72px] md:pl-5 pb-10 lg:pb-0">
							<div class="relative z-10 md:rotate-[-5deg]">
								<img class="bg-cover" width="336" height="666" src={appMockup1} alt="mockup" />
							</div>
							<div class="flex flex-col items-center md:items-start md:pt-7 gap-5 md:gap-12">
								<h1 class="animate-up break-words text-[42px] md:text-[65px] leading-none font-light after:bg-star after:bg-no-repeat after:size-4 after:inline-block after:relative after:-top-1.5 after:-right-1.5"><b class="font-semibold">Understand your people like never before.</b> <span class="opacity-70">Soul-aligned insights for every connection in your life</span></h1>
								<div class="hidden md:flex justify-center md:justify-start">
									<ButtonPrimary className="text-xl !font-semibold"  onClick={gotoTest} title="Take the Free Test Now" />
								</div>
							</div>
						</div>
					</div>
					</swiper-slide>
				</swiper-container>
			</div>
				<div class="animate-up flex md:hidden justify-center mt-12">
					<ButtonPrimary className="max-w-[284px] text-xl !font-semibold"  onClick={gotoTest} title="Take the Free Test Now" />
				</div>
				<div class="max-w-[392px] md:max-w-[840px] px-2.5 md:px-5 mx-auto mt-20">
						<div class="animate-up grid grid-cols-3 sm:flex flex-wrap gap-1.5 md:gap-2.5 justify-center">
							<div class="flex flex-col gap-1 items-center bg-black/20 rounded-[20px] w-full sm:w-[120px] md:w-[150px] aspect-square shrink-0 justify-center pb-2">
								<img width="90" height="90" src={symbolFramworkEnnegram} alt="symbol" />
								<div class="text-xs leading-[14px] text-center">Enneagram</div>
							</div>
							<div class="flex flex-col gap-1 items-center bg-black/20 rounded-[20px] w-full sm:w-[120px] md:w-[150px] aspect-square shrink-0 justify-center pb-2">
								<img width="90" height="90" src={symbolFramworkHumandesign} alt="symbol" />
								<div class="text-xs leading-[14px] text-center">Human Design</div>
							</div>
							<div class="flex flex-col gap-1 items-center bg-black/20 rounded-[20px] w-full sm:w-[120px] md:w-[150px] aspect-square shrink-0 justify-center pb-2">
								<img width="90" height="90" src={symbolFramworkGenekeys} alt="symbol" />
								<div class="text-xs leading-[14px] text-center">Gene Keys</div>
							</div>
							<div class="flex flex-col gap-1 items-center bg-black/20 rounded-[20px] w-full sm:w-[120px] md:w-[150px] aspect-square shrink-0 justify-center pb-2">
								<img width="90" height="90" src={symbolFramworkWesternastrology} alt="symbol" />
								<div class="text-xs leading-[14px] text-center">Western Astrology</div>
							</div>
							<div class="flex flex-col gap-1 items-center bg-black/20 rounded-[20px] w-full sm:w-[120px] md:w-[150px] aspect-square shrink-0 justify-center pb-2">
								<img width="90" height="90" src={symbolFramworkVedicastrology} alt="symbol" />
								<div class="text-xs leading-[14px] text-center">Vedic Astrology</div>
							</div>
							<div class="flex flex-col gap-1 items-center bg-black/20 rounded-[20px] w-full sm:w-[120px] md:w-[150px] aspect-square shrink-0 justify-center pb-2">
								<img width="90" height="90" src={symbolFramworkChineseastrology} alt="symbol" />
								<div class="text-xs leading-[14px] text-center">Chinese Astrology</div>
							</div>
							<div class="flex flex-col gap-1 items-center bg-black/20 rounded-[20px] w-full sm:w-[120px] md:w-[150px] aspect-square shrink-0 justify-center pb-2">
								<img width="90" height="90" src={symbolFramworkSpiraldynamics} alt="symbol" />
								<div class="text-xs leading-[14px] text-center">Spiral Dynamics</div>
							</div>
							<div class="flex flex-col gap-1 items-center bg-black/20 rounded-[20px] w-full sm:w-[120px] md:w-[150px] aspect-square shrink-0 justify-center pb-2">
								<img width="90" height="90" src={symbolFramworkNumerology} alt="symbol" />
								<div class="text-xs leading-[14px] text-center">Numerology</div>
							</div>
							<div class="flex flex-col gap-1 items-center bg-black/20 rounded-[20px] w-full sm:w-[120px] md:w-[150px] aspect-square shrink-0 justify-center pb-2">
								<img width="90" height="90" src={symbolInteraction} alt="symbol" />
								<div class="text-xs leading-[14px] text-center">Soulprint<br>Combinations</div>
							</div>
						</div>
				</div>

				<div class="max-w-[555px] px-5 mx-auto mt-6">
					<div class="flex flex-col text-center gap-2">
						<h2 class="animate-up text-center text-[40px] leading-[44px] font-semibold">Your Soulprint Synthesizes Insight & Wisdom</h2>
						<p class="animate-up text-[17px] leading-6 font-light">From the best frameworks to create the most multidimensional, insightful reflection of yourself that you’ve ever experienced.</p>
					</div>
				</div>
			</div>
	</section>

	

	<section class="overflow-hidden bg-white py-16 md:py-44">
		<div class="max-w-[1120px] px-5 mx-auto">
			<div class="flex flex-col md:flex-row gap-5 md:gap-10 lg:gap-[74px] items-center">
				<div class="flex flex-col gap-[26px] md:max-w-[347px]">
					<h2 class="animate-up gradient-text text-[40px] leading-[44px] font-semibold">Explore your Soulprint and get Answers to...</h2>
					<div class="animate-up flex flex-col gap-4 text-[17px] leading-6 text-black">
						<p>It is your opportunity to walk your Golden Path in life with a precision that has never been possible before.</p>
						<p>We use generative AI guided by our deep compassion and empathy for the Soul’s journey to masterfully craft insights which guide you in every area of your life.</p>
						<p>It is truly a work of art and magic.</p>
					</div>
				</div>
				<ul class="flex-1 flex flex-col gap-3 md:gap-5 text-[13px] leading-5 md:text-[23px] md:leading-8 items-start -mx-2.5 md:mx-0">
					<li class="animate-right bg-[#4D4F9A] py-1.5 md:py-2 pl-2.5 md:pl-4 pr-3 md:pr-6 flex gap-2 md:gap-3 rounded-lg md:rounded-xl">
						<img class="shrink-0 w-3 md:w-5" width="20" height="20" src={arrowIconB} alt="icon" />
						<span>What is my <strong>PURPOSE</strong>?</span>
					</li>
					<li class="animate-right bg-[#4D4F9A] py-1.5 md:py-2 pl-2.5 md:pl-4 pr-3 md:pr-6 flex gap-2 md:gap-3 rounded-lg md:rounded-xl">
						<img class="shrink-0 w-3 md:w-5" width="20" height="20" src={arrowIconB} alt="icon" />
						<span>How do I create long lasting <strong>WEALTH</strong>?</span>
					</li>
					<li class="animate-right bg-[#4D4F9A] py-1.5 md:py-2 pl-2.5 md:pl-4 pr-3 md:pr-6 flex gap-2 md:gap-3 rounded-lg md:rounded-xl">
						<img class="shrink-0 w-3 md:w-5" width="20" height="20" src={arrowIconB} alt="icon" />
						<span>How do I attract my <strong>LIFE PARTNER</strong>?</span>
					</li>
					<li class="animate-right bg-[#4D4F9A] py-1.5 md:py-2 pl-2.5 md:pl-4 pr-3 md:pr-6 flex gap-2 md:gap-3 rounded-lg md:rounded-xl">
						<img class="shrink-0 w-3 md:w-5" width="20" height="20" src={arrowIconB} alt="icon" />
						<span>How do I create harmony in my <strong>RELATIONSHIPS</strong>?</span>
					</li>
					<li class="animate-right bg-[#4D4F9A] py-1.5 md:py-2 pl-2.5 md:pl-4 pr-3 md:pr-6 flex gap-2 md:gap-3 rounded-lg md:rounded-xl">
						<img class="shrink-0 w-3 md:w-5" width="20" height="20" src={arrowIconB} alt="icon" />
						<span>How do I become <strong>HEALTHY</strong> and full of <strong>ENERGY</strong>?</span>
					</li>
					<li class="animate-right bg-[#4D4F9A] py-1.5 md:py-2 pl-2.5 md:pl-4 pr-3 md:pr-6 flex gap-2 md:gap-3 rounded-lg md:rounded-xl">
						<img class="shrink-0 w-3 md:w-5" width="20" height="20" src={arrowIconB} alt="icon" />
						<span>What is the correct <strong>CAREER</strong> for me?</span>
					</li>
				</ul>
			</div>

		</div>
	</section>

	<section class="overflow-hidden bg-white py-0 md:py-7">
		<div class="max-w-[1120px] px-5 mx-auto">
			<div class="flex flex-col md:flex-row gap-16 md:gap-10 lg:gap-[74px] items-center">
				<div class="flex flex-col gap-[26px] md:max-w-[347px] shrink-0">
					<h2 class="animate-up gradient-text text-[40px] leading-[44px] font-semibold">Deep Dive into your Soulprint and Systems</h2>
					<div class="animate-up flex flex-col gap-4 text-[17px] leading-6 text-black">
						<p>Unlock 10,000+ words of transformative Insight to help you live your best life with the TrueSelf Soulprint!</p>
						<p>Explore the 8 systems that we integrate into your Soulprint and get a deeper understanding of those aspects</p>
					</div>
					<div class="animate-up hidden md:flex justify-start">
						<ButtonSecondaryLight className="!from-[#2C419A] !to-[#7357A4] !border-none text-xl text-white !ring-0 font-semibold max-w-[284px]" title="Take the Free Test Now"  onClick={gotoTest}/>
					</div>
				</div>
				<div class="grid grid-cols-2 gap-2.5 md:gap-[18px] -mx-2.5 md:mx-0">
					<img class="animate-up w-full md:w-[329px] relative -top-6" width="329" height="500" src={soulprintLifeAreasScreenshot} alt="screenshot" />
					<img class="animate-up w-full md:w-[329px] relative top-6" width="329" height="500" src={soulprintSystemScreenshot} alt="screenshot" />
				</div>
				<div class="animate-up flex md:hidden justify-center">
					<ButtonSecondaryLight className="!from-[#2C419A] !to-[#7357A4] !border-none text-xl text-white !ring-0 font-semibold max-w-[284px]" title="Take the Free Test Now"  onClick={gotoTest}/>
				</div>
			</div>
		</div>
	</section>

 

	 <section class="overflow-hidden bg-white px-2.5 md:px-5 py-20">
			<div class="bg-[#FAFAFA] rounded-[30px] flex flex-col max-w-[1372px] mx-auto gap-12 md:gap-16 py-14 md:py-20 lg:py-36">
				<h2 class="animate-up gradient-text text-[40px] leading-[44px] font-semibold text-center">Accurate & Impactful.</h2>
				<div class="grid grid-cols-1 md:grid-cols-3 gap-[60px] max-w-[1165px] px-5 mx-auto text-[#5F256C]">
					<SalesTestimonials 
						className="animate-up"
						imageSrc={user2}
						altText="Christopher"
						testimonialText="“Wow that soul print is definitely the best reflection I have felt in a long time...”"
						name="Christopher"
						designation="Entrepreneur, Designer, MBA"
					/>
					<SalesTestimonials 
						className="animate-up"
						imageSrc={user1}
						altText="Becky"
						testimonialText="“I have never read a report that's made me cry!  Feel so seen!”"
						name="Becky"
						designation="Writer, Coach, Yoga Teacher"
					/>
					<SalesTestimonials 
						className="animate-up"
						imageSrc={user4}
						altText="Daniel Raphael"
						testimonialText="“Holy Amazeballs… how did you do that?”"
						name="Daniel Raphael"
						designation="Founder of Dreamporting.com, Spiritual Teacher to Thousands"
					/>
				</div>
			</div>
	 </section>

	 <section class="overflow-hidden bg-white pt-0 pb-20 md:pt-20 md:pb-28">
		<div class="max-w-[1093px] px-5 mx-auto">
			<div class="flex flex-col md:flex-row md:items-center gap-6 md:gap-0 relative z-0">
				<div class="animate-left flex -mr-5 md:mr-0 md:-ml-40 relative md:left-40 md:-top-10 -z-10 overflow-hidden">
					<img class="w-[611px] max-w-none md:max-w-full md:w-full" width="800" height="406" src={headphone} alt="headphone" />
				</div>
				<div class="animate-right flex flex-col gap-[26px] md:max-w-[347px] shrink-0">
					<h2 class="gradient-text text-[40px] leading-[44px] font-semibold pb-0.5">Listen to<br/>your Readings</h2>
					<div class="flex flex-col gap-4 text-[17px] leading-6 text-black">
						<p>Don't like reading long test. Listen to your Soulprint like a podcast!</p>
					</div>
					<div class="flex justify-start">
						<AudioPlayerOriginal className="!bg-[#6B5295] !my-0" title="Listen to your Soulprint" src="../sample.mp3" />  
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="overflow-hidden bg-white px-2.5 md:px-5 py-2.5">
		<div class="bg-[#FAFAFA] rounded-[30px] max-w-[1372px] mx-auto pb-8 pt-4 md:py-4">
			<div class="flex flex-col-reverse md:flex-row items-center gap-5 md:gap-10 justify-between max-w-[963px] px-5 mx-auto">
				<div class="flex flex-col gap-[26px] md:max-w-[347px] shrink-0">
					<h2 class="animate-up gradient-text text-[40px] leading-[44px] font-semibold">Connect<br/>Reflect & Grow.</h2>
					<div class="animate-up flex flex-col gap-4 text-[17px] leading-6 text-black">
						<p>Once inside, you can invite your friends, family, romantic interests, and co-workers, to explore their Soulprint and learn about your unique alignments and relational variables.</p>
						<p>You can also create groups for teams, communities, or events, to easily learn about one another through your unique Soulprints.</p>
					</div>
					<div class="animate-up flex justify-start">
						<ButtonSecondaryLight className="!from-[#2C419A] !to-[#7357A4] !border-none text-xl text-white !ring-0 font-semibold max-w-[195px]" title="Take the Test" onClick={gotoTest}/>
					</div>
				</div>
				<div class="animate-shake flex justify-center">
					<img class="rotate-[12deg] w-[220px] md:w-[326px]" width="326" height="647" src={appMockup1} alt="mockup">
				</div>
			</div>
		</div>
 </section>

 <section class="overflow-hidden bg-white px-2.5 md:px-5 py-2.5">
	<div class="bg-[#FAFAFA] rounded-[30px] max-w-[1372px] mx-auto pb-8 pt-4 md:py-4">
		<div class="flex flex-col md:flex-row items-center gap-5 md:gap-10 justify-between max-w-[963px] px-5 mx-auto">
			<div class="animate-shake flex justify-center">
				<img class="rotate-[-12deg] w-[220px] md:w-[326px]" width="326" height="647" src={appMockup2} alt="mockup">
			</div>
			<div class="flex flex-col gap-[26px] md:max-w-[347px] shrink-0">
				<h2 class="animate-up gradient-text text-[40px] leading-[44px] font-semibold">Talk to your<br/>Cosmic Guide.</h2>
				<div class="animate-up flex flex-col gap-4 text-[17px] leading-6 text-black">
					<p>This is the space to deepen your understanding of your Soulprint and its practical applications</p>
					<p>Your Soulprint is added into an interactive chat interface called The Cosmic Guide, where you can ask any question you’ve asked an AI chatbot before – but now in the context of your unique TrueSelf Soulprint.</p>
				</div>
				<div class="animate-up flex justify-start">
					<ButtonSecondaryLight className="!from-[#2C419A] !to-[#7357A4] !border-none text-xl text-white !ring-0 font-semibold max-w-[195px]" title="Take the Test"  onClick={gotoTest}/>
				</div>
			</div>
		</div>
	</div>
</section>

	<section class="overflow-hidden bg-white py-20 md:py-40">
		<div class="max-w-[1187px] px-5 mx-auto">
			<div class="flex flex-col gap-10">
				<h2 class="animate-up gradient-text text-[40px] leading-[44px] font-semibold pb-0.5 text-center">Simplicity, Clarity & Depth</h2>
				<div class="flex flex-col md:grid md:grid-cols-3 items-center md:items-start gap-5 md:gap-2.5 text-center">
					<img class="animate-up" width="363" src={testimonialMsg1} alt="comment" />
					<img class="animate-up" width="363" src={testimonialMsg2} alt="comment" />
					<img class="animate-up" width="363" src={testimonialMsg3} alt="comment" />
			 </div>
			</div>
		</div>
	 </section>

	 <section class="overflow-hidden bg-white pb-20 md:pb-28">
	 <div class="max-w-[1119px] flex flex-col px-5 gap-8 md:gap-10 mx-auto w-full">
		<h2 class="animate-up gradient-text text-[40px] leading-[44px] font-semibold pb-0.5 text-center">Core growth<br/>opportunities.</h2>
		 <div class="grid grid-cols-1 md:grid-cols-3 w-full gap-2.5">
			<SalesAboutCard
				className="animate-up !bg-[#FAFAFA]"
				imageSrc={iconHeart}
				title="Your Inner World"
				text="Discover the subconscious patterns secretly governing your reality and how they get in the way of what you truly desire"
			/>
			<SalesAboutCard
				className="animate-up !bg-[#FAFAFA]"
				imageSrc={iconEye}
				title="Blind Spots & False Beliefs"
				text="Learn about the hidden programs buried deep in your personality that have you living a fraction of your true potential and greatness."
			/>
			<SalesAboutCard
				className="animate-up !bg-[#FAFAFA]"
				imageSrc={iconStar}
				title="Instinctual Drives"
				text="Learn how your personality type can best feel safe, socially recognized and accepted, and attract the love of your life"
			/>
			<SalesAboutCard
				className="animate-up !bg-[#FAFAFA]"
				imageSrc={iconGraph}
				title="Your Growth Path"
				text="Learn how to overcome challenges you have been facing your whole life and develop the habits, awareness and tools to stay in your zone of genius"
			/>
			<SalesAboutCard
				className="animate-up !bg-[#FAFAFA]"
				imageSrc={iconPuls}
				title="Health and Diet"
				text="Discover how your personality type relates to health and diet and how this awareness can dramatically increase your fitness, vitality and passion for life"
			/>
			<SalesAboutCard
				className="animate-up !bg-[#FAFAFA]"
				imageSrc={iconSuitcase}
				title="Career"
				text="Discover what type of jobs and careers are most suited to your personality...and also which ones are not"
			/>
		 </div>
	</div>
</section>

	 
<section class="overflow-hidden pt-20 pb-20 md:pb-36 relative z-10 after:-z-10 after:bg-black/40 after:inset-0 after:size-full after:absolute">
	<img class="bg-cover absolute inset-0 size-full -z-10" src={bg} alt="background" />
	<div class="flex flex-col gap-10 md:gap-16 max-w-[1152px] mx-auto px-2.5 md:px-5">
		<h2 class="animate-up text-transparent font-semibold text-[40px] leading-[48px] bg-clip-text bg-gradient-to-br from-white to-white/80 text-center">8 Core Soulprint<br/>Frameworks</h2>
		<div class="flex flex-col w-full gap-[18px]">
			<div class="animate-up flex flex-col md:flex-row items-center px-5 md:px-10 lg:px-28 gap-10 lg:gap-28 bg-black/10 rounded-[30px] pt-0 pb-7 md:py-11">
				<div class="relative md:-top-5">
					<img width="310" height="310" src={symbolFramworkEnnegram} alt="symbol" />
					<img class="absolute -bottom-5 left-1/2 -translate-x-1/2" width="183" height="59" src={textEnneagram} alt="text" />
				</div>
				<div class="flex flex-col max-w-[400px]">
					<h4 class="mb-5 text-transparent font-semibold text-3xl leading-8 bg-clip-text bg-gradient-to-br from-white to-white/80">Unlock the blueprint of your core motivations, fears, and patterns</h4>
					<p class="mb-7 text-[17px] leading-6 text-white">Gain the clarity to overcome self-sabotage, transform your relationships, and live with purpose and confidence.</p>
					<div class="flex justify-start">
						<ButtonPrimary className="text-xl !font-semibold max-w-[207px]"  onClick={gotoTest} title="Take the Test"  />
					</div>
				</div>
			</div>

			<div class="animate-up flex flex-col md:flex-row items-center px-5 md:px-10 lg:px-28 gap-10 lg:gap-28 bg-black/10 rounded-[30px] pt-0 pb-7 md:py-11">
				<div class="relative md:-top-5">
					<img width="310" height="310" src={symbolFramworkWesternastrology} alt="symbol" />
					<img class="absolute -bottom-5 left-1/2 -translate-x-1/2" width="288" height="66" src={textWesternAstrology} alt="text" />
				</div>
				<div class="flex flex-col max-w-[400px]">
					<h4 class="mb-5 text-transparent font-semibold text-3xl leading-8 bg-clip-text bg-gradient-to-br from-white to-white/80">Your cosmic roadmap to your purpose, strengths, and challenges. </h4>
					<p class="mb-7 text-[17px] leading-6 text-white">Unlock the wisdom of the stars to navigate life with clarity, confidence, and alignment.</p>
					<div class="flex justify-start">
						<ButtonPrimary className="text-xl !font-semibold max-w-[207px]"  onClick={gotoTest} title="Take the Test" />
					</div>
				</div>
			</div>

			<div class="animate-up flex flex-col md:flex-row items-center px-5 md:px-10 lg:px-28 gap-10 lg:gap-28 bg-black/10 rounded-[30px] pt-0 pb-7 md:py-11">
				<div class="relative md:-top-5">
					<img width="310" height="310" src={symbolFramworkVedicastrology} alt="symbol" />
					<img class="absolute -bottom-5 left-1/2 -translate-x-1/2" width="245" height="66" src={textVedicAstrology} alt="text" />
				</div>
				<div class="flex flex-col max-w-[400px]">
					<h4 class="mb-5 text-transparent font-semibold text-3xl leading-8 bg-clip-text bg-gradient-to-br from-white to-white/80">Unleash the deep wisdom of the Vedic tradition.</h4>
					<p class="mb-7 text-[17px] leading-6 text-white">Discover the keys to navigate each stage of your life and prepare for the next with confidence.</p>
					<div class="flex justify-start">
						<ButtonPrimary className="text-xl !font-semibold max-w-[207px]"  onClick={gotoTest} title="Take the Test" />
					</div>
				</div>
			</div>

			<div class="animate-up flex flex-col md:flex-row items-center px-5 md:px-10 lg:px-28 gap-10 lg:gap-28 bg-black/10 rounded-[30px] pt-0 pb-7 md:py-11">
				<div class="relative md:-top-5">
					<img width="310" height="310" src={symbolFramworkGenekeys} alt="symbol" />
					<img class="absolute -bottom-5 left-1/2 -translate-x-1/2" width="150" height="66" src={textGeneKeys} alt="text" />
				</div>
				<div class="flex flex-col max-w-[400px]">
					<h4 class="mb-5 text-transparent font-semibold text-3xl leading-8 bg-clip-text bg-gradient-to-br from-white to-white/80">Reveal the hidden potential within your DNA, turning shadows into strengths.</h4>
					<p class="mb-7 text-[17px] leading-6 text-white">Unlock the path to prosperity, love, and deep inner peace written in your very being.</p>
					<div class="flex justify-start">
						<ButtonPrimary className="text-xl !font-semibold max-w-[207px]"  onClick={gotoTest} title="Take the Test" />
					</div>
				</div>
			</div>

		</div>
		<h3 class="animate-up text-transparent font-semibold text-3xl leading-8 bg-clip-text bg-gradient-to-br pb-0.5 from-white to-white/80 text-center">Also includes these amazing Frameworks</h3>
		<div class="grid grid-cols-2 md:grid-cols-4 gap-2.5 md:gap-4">
			<div class="animate-up flex flex-col items-center justify-center gap-3.5 p-5 bg-black/10 rounded-[30px] aspect-square">
				<img class="size-[110px] md:size-[158px]" width="158" height="158" src={symbolFramworkHumandesign} alt="symbol" />
				<img class="w-[120px] md:w-[191px]" width="191" height="30" src={textHumanDesign} alt="text" />
			</div>
			<div class="animate-up flex flex-col items-center justify-center gap-3.5 p-5 bg-black/10 rounded-[30px] aspect-square">
				<img class="size-[110px] md:size-[158px]" width="158" height="158" src={symbolFramworkChineseastrology} alt="symbol" />
				<img class="w-[132px] md:w-[189px]" width="189" height="36" src={textChineseAstrology} alt="text" />
			</div>
			<div class="animate-up flex flex-col items-center justify-center gap-3.5 p-5 bg-black/10 rounded-[30px] aspect-square">
				<img class="size-[110px] md:size-[158px]" width="158" height="158" src={symbolFramworkSpiraldynamics} alt="symbol" />
				<img class="w-[135px] md:w-[194px]" width="194" height="35" src={textSpiralDynamics} alt="text" />
			</div>
			<div class="animate-up flex flex-col items-center justify-center gap-3.5 p-5 bg-black/10 rounded-[30px] aspect-square">
				<img class="size-[110px] md:size-[158px]" width="158" height="158" src={symbolFramworkNumerology} alt="symbol" />
				<img class="w-[100px] md:w-[140px]" width="140" height="30" src={textNumerology} alt="text" />
			</div>
		</div>
	</div>
</section>

	 <section class="overflow-hidden bg-white py-20 text-[#5F256C]">
		<div class="max-w-[1218px] px-5 mx-auto">
			<h2 class="animate-up gradient-text text-[40px] leading-[44px] font-semibold pb-0.5 text-center mb-3 max-w-[571px] mx-auto">Power, Ecstasy and Wisdom of Self-Knowledge</h2>
			<p class="animate-up text-[17px] leading-6 text-black text-center max-w-[626px] mx-auto">Philosophers, Billionaires, Enlightened Sages and Mystics throughout the Ages have understood the Power, Ecstasy and Wisdom of Self-Knowledge</p>
			<div class="flex flex-col items-center md:items-start md:grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8 mt-7">
				<SalesBigFigures 
						className="animate-up"
						imageSrc={personCarl}
						altText="Carl Jung"
						testimonialText="“The privilege of a lifetime is to become who you truly are.”"
						name="Carl Jung"
				/>
				<SalesBigFigures 
					className="animate-up"
					imageSrc={personBrown}
					altText="Brené Brown"
					testimonialText="“Owning our story and loving ourselves through that process is the bravest thing that we will ever do.”"
					name="Brené Brown"
				/>
				<SalesBigFigures 
					className="animate-up"
					imageSrc={personTole}
					altText="Eckhart Tolle"
					testimonialText="“Only the truth of who you are, if realized, will set you free.”"
					name="Eckhart Tolle"
				/>
			</div>
		</div>
	 </section>

	  

	 

	  

	  

  
		
	 <section class="overflow-hidden pt-0 md:pt-10 pb-20 lg:pt-20 lg:pb-40 bg-white text-white md:text-black relative z-10 md:after:hidden after:-z-10 after:bg-black/40 after:inset-0 after:size-full after:absolute">
		<img class="bg-cover absolute inset-0 size-full -z-10 md:hidden" src={bg} alt="background" />
		<div class="max-w-[1314px] mx-auto px-5 w-full">
			<div class="flex flex-col lg:flex-row gap-10">
				<div class="animate-up bg-white md:bg-[#FAFAFA] py-10 px-5 md:p-12 rounded-3xl order-2 md:order-1">
					<div class="flex flex-col gap-4 text-[17px] leading-6 text-black">
						<p><strong>Our promise:</strong></p>
						<p>You’ve never seen anything like this—because it’s never been possible before.</p>
						<p>Self Soulprint isn’t just another personality test. Unlike Astrology, Enneagram, or Human Design, it’s not based on generic archetypes. Instead, our dynamic algorithm, trained by world-class experts, generates a uniquely tailored reading—live, in real-time.</p>
						<p>Rooted in ancient wisdom once hidden in mystery schools, the Soulprint delivers clarity that would take thousands of dollars and years of study to achieve on your own.</p>
						<p>Now, it’s finally accessible to you.</p>
					</div>
				</div>
				<div class="animate-up flex flex-col gap-4 lg:max-w-[347px] shrink-0 order-1 md:order-2 relative pt-40 md:pt-0 overflow-hidden">
					<div class="absolute md:hidden w-[169px] -right-8 top-[3rem] justify-center shrink-0">
						<img width="169" height="246" src={starsLinesXS} alt="stars" />
					</div>
					<h2 class="gradient-text text-[40px] hidden md:block leading-[44px] pb-1 font-semibold">The Unique<br/>Soulprint Technology</h2>
					<h2 class="text-white text-[40px] md:hidden leading-[44px] font-semibold">The Unique<br/>Soulprint Technology</h2>
					<div class="flex flex-col gap-4 text-[17px] leading-6">
						<p>Cutting edge generative AI technologies are used to tap into metaphysical secrets about the nature of reality, psyche, soul and consciousness.</p>
						<p>The Soulprint is TrueSelf’s revolutionary new technology that uses the latest breakthroughs in artificial intelligence to synthesize a myriad of systems together to capture the unique Soul Essence that is YOU. </p>
					</div>
					<div class="hidden md:flex justify-start mt-2">
						<ButtonSecondaryLight className="!from-[#2C419A] !to-[#7357A4] !border-none text-xl text-white !ring-0 font-semibold max-w-[281px]" title="Take the Free Test Now"  onClick={gotoTest}/>
					</div>
				</div>
				<div class="animate-up hidden md:flex lg:w-[344px] justify-center shrink-0 order-3">
					<img width="344" height="501" src={starsLines} alt="stars" />
				</div>
				<div class="animate-up flex md:hidden justify-center  order-3">
					<ButtonPrimary className="max-w-[284px] text-xl !font-semibold"  onClick={gotoTest} title="Take the Free Test Now"  />
				</div>
			</div>
		</div>
	</section>

  
<div class="overflow-hidden pt-20 relative after:-z-10 after:bg-black/40 after:inset-0 after:size-full after:absolute">
 <section class="pb-20">
	<img class="bg-cover absolute inset-0 size-full -z-10" src={bg} alt="background" />
	<div class="max-w-[1125px] px-5 mx-auto w-full mb-16 md:mb-24">
		<div class="flex flex-col gap-10 md:gap-20">
			<div class="w-full">
				<h2 class="animate-up text-transparent font-semibold text-[40px] leading-[48px] bg-clip-text bg-gradient-to-br from-white to-white/80 text-center mb-3 max-w-[403px] mx-auto">Accelerated Path to Self-Actualization</h2>
				<p class="animate-up text-white font-light text-[17px] leading-[23px] mb-8 text-center">Self-Actualized Individuals experience benefits such as:</p>
				 <div class="grid grid-cols-1 md:grid-cols-3 w-full gap-2.5">
					<SalesAboutCard
						className="animate-up bg-white/10 text-white"
						imageSrc={iconEye2Wt}
						imageSize="large"
						title="They have a superior perception of reality"
						text="They are more objective and less influenced by their conditioning."
					/>
					<SalesAboutCard
					  className="animate-up bg-white/10 text-white"
						imageSrc={iconIndividualWt}
						imageSize="large"
						title="They have an increased sense of autonomy and individuality"
						text="They experience a greater sense of agency and responsibility for their life."
					/>
					<SalesAboutCard
					  className="animate-up bg-white/10 text-white"
						imageSrc={iconThemselvesWt}
						imageSize="large"
						title="They are comfortable being themselves"
						text="They don't try to conform or seek approval from others."
					/>
					<SalesAboutCard
						className="animate-up bg-white/10 text-white"
						imageSrc={iconRelationshipsWt}
						imageSize="large"
						title="They have better interpersonal relationships"
						text="They are better at listening, understanding and communicating with others."
					/>
					<SalesAboutCard
						className="animate-up bg-white/10 text-white"
						imageSrc={iconInnovativeWt}
						imageSize="large"
						title="They are more creative and innovative"
						text="They have greater access to creativity and spontaneity."
					/>
					<SalesAboutCard
						className="animate-up bg-white/10 text-white"
						imageSrc={iconTalentsWt}
						imageSize="large"
						title="They cultivate their unique skills & talents"
						text="They work toward excellence in what is important to them."
					/>
					<SalesAboutCard
						className="animate-up bg-white/10 text-white"
						imageSrc={iconTalentsWt}
						imageSize="large"
						title="Live on purpose with a sense of mission"
						text="Their work is an important personal cause that they take great pride in."
					/>
					<SalesAboutCard
						className="animate-up bg-white/10 text-white"
						imageSrc={iconPeakWt}
						imageSize="large"
						title="They have a higher frequency of peak experiences"
						text="The have easier access to the flow states and spend more time in peak experiences."
					/>
					<SalesAboutCard
						className="animate-up bg-white/10 text-white"
						imageSrc={iconUnityWt}
						imageSize="large"
						title="Constantly moving towards unity and integration"
						text="They synthesize all information into a deeper understanding."
					/>
				 </div>
			</div>

		</div>
	</div>

	<div class="overflow-hidden animate-up max-w-[740px] px-5 mx-auto w-full" id="faq">
		<FreeSoulprintFaq />
	</div>
 </section>

 	<Footer showSettings={false}/>
</div>
</AppWrapper>

